const toggle = document.getElementById("megaMenuToggle");
const menu = document.getElementById("megaMenu");
const wrapper = document.querySelector(".mega-menu-wrapper");

toggle.addEventListener("mouseenter", () => {

  menu.classList.toggle("active");
  wrapper.classList.toggle("open");

});

/* cerrar si hacen click fuera */
document.addEventListener("mouseout", function(e){

  if(!wrapper.contains(e.target)){
    menu.classList.remove("active");
    wrapper.classList.remove("open");
  }

});